import { useNavigate } from 'react-router-dom';
import { Col, DatePicker, Input, Row } from 'antd';
import { useGetGendersQuery, useGetNameSuffixesQuery, useGetRacesQuery } from '@/services/general-api';
import { SaveSvg, UserSvg } from '@/assets/icons';
import Select from '@/components/select';
import Panel from '@/components/panel';
import FixedFooter from '@/components/fixed-footer';
import Button from '@/components/button';
import { Form } from './styles';
import { useGetGroupMembersQuery, useAddGroupMembersMutation } from '@/services/sibling-group-api';
import _ from 'lodash';
import moment from 'moment';

const { TextArea } = Input;

const AddForm = ({ groupData }) => {
  const navigate = useNavigate();

  const { data: suffixData, isLoading: loadingSuffixData } = useGetNameSuffixesQuery();
  const { data: genderData, isLoading: loadingGenderData } = useGetGendersQuery();
  const { data: raceData, isLoading: loadingRaceData } = useGetRacesQuery();
  const [addMembers, { isLoading: adding }] = useAddGroupMembersMutation();

  const { data: groupMembers, isLoading: loadingGroupMembers } = useGetGroupMembersQuery({
    groupId: groupData.siblingGroupId,
  });

  const [form] = Form.useForm();

  const onFinish = async (values) => {
    const body = {
      children: [
        {
          ..._.cloneDeep(values),
          childCode: groupData.childCode + String.fromCharCode(65 + groupMembers?.count),
          bioUpdating: false,
          hasBio: values.bio ? true : false,
        },
      ],
    };
    body.children[0].birthInfo.date = body.children[0].birthInfo.date.toISOString();

    try {
      await addMembers({ groupId: groupData.siblingGroupId, body }).unwrap();
      navigate('../view');
    } catch (err) {}
  };

  return (
    <Form layout="vertical" form={form} onFinish={onFinish} loading={loadingGroupMembers} style={{ marginBottom: 58 }}>
      <Panel
        icon={<UserSvg />}
        title={`Child - ${groupData.childCode + String.fromCharCode(65 + groupMembers?.count)}`}
      >
        <Row gutter={32}>
          <Col xs={24} md={12} xl={8}>
            <Form.Item name={['name', 'first']} label="First Name" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} xl={8}>
            <Form.Item name={['name', 'last']} label="Last Name" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} xl={8}>
            <Form.Item name={['name', 'suffix']} label="Suffix">
              <Select options={suffixData} valueName="code" loading={loadingSuffixData} allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} xl={8}>
            <Form.Item name={['birthInfo', 'date']} label="Birth Date" rules={[{ required: true }]}>
              <DatePicker
                format="MM/DD/YYYY"
                onBlur={(e) => {
                  const inputVal = e.target.value;
                  const validDate = moment(inputVal, ['M/D/YYYY', 'MM/DD/YYYY'], true);
                  if (validDate.isValid()) {
                    form.setFieldsValue({
                      birthInfo: { date: validDate },
                    });
                  } else {
                    form.setFieldsValue({
                      birthInfo: { date: null },
                    });
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} xl={8}>
            <Form.Item name={['gender', 'id']} label="Gender" rules={[{ required: true }]}>
              <Select options={genderData} loading={loadingGenderData} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} xl={8}>
            <Form.Item name={['race', 'id']} label="Race/Ethnicity" rules={[{ required: true }]}>
              <Select options={raceData} loading={loadingRaceData} showSearch />
            </Form.Item>
          </Col>
          <Col xs={24}>
            <Form.Item name={['bio']} label="Bio">
              <TextArea autoSize={{ minRows: 2 }} />
            </Form.Item>
          </Col>
        </Row>
      </Panel>

      <FixedFooter>
        <Button type="primary" htmlType="submit" icon={<SaveSvg />} loading={adding}>
          Save
        </Button>
      </FixedFooter>
    </Form>
  );
};

export default AddForm;
